// extracted by mini-css-extract-plugin
export var centerText = "_ek-8";
export var container = "_ek-0";
export var doughnutContainer = "_ek-7";
export var legend = "_ek-a";
export var legendItemColorDisplay = "_ek-b";
export var legendItemLabel = "_ek-d";
export var legendItemValue = "_ek-c";
export var lg = "_ek-5";
export var maxWidth = "_ek-9";
export var md = "_ek-4";
export var responsive = "_ek-6";
export var sm = "_ek-3";
export var xs = "_ek-2";
export var xxs = "_ek-1";